module.exports = __webpack_public_path__ + "img/transmission.d8a3b0d3.svg";